import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  title: {
    margin: "60px 0 0 0",
    color: colors.orange,
    fontSize: 42,
    fontWeight: 600,
    [Commons.smallQuery]: {
      fontSize: 24,
    },
  },
  cardCoupon: {
    display: "inline-block",
    position: "relative",
    margin: "30px 15px 0 15px",
    boxShadow: colors.shadowWhite,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: colors.white,
    width: 300,
    height: "90%",
    [Commons.smallQuery]: {
      height: "auto",
      width: "calc(100% - 30px)",
      display: "flex",
      boxSizing: "border-box",
    },
  },
  imgCardCoupon: {
    width: "100%",
    height: 180,
    objectFit: "cover",
    backgroundColor: colors.gray50,
    [Commons.smallQuery]: {
      width: 90,
      height: "auto",
    },
  },
  infoCardCoupon: {
    padding: 12,
    whiteSpace: "wrap",
  },
  labelCardCoupon: {
    color: colors.black,
    fontSize: 18,
    margin: "12px 0",
    fontWeight: "bold",
    minHeight: 48,
    [Commons.smallQuery]: {
      fontSize: 16,
      minHeight: 46,
    },
  },
  priceCardCoupon: {
    ...Commons.ellipsis,
    color: colors.primary,
    fontSize: 18,
    margin: "12px 0",
    fontWeight: "500",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  emailCardCoupon: {
    ...Commons.ellipsis,
    color: colors.black,
    fontSize: 15,
    margin: "12px 0",
    fontWeight: "400",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  buttonCardCoupon: {
    ...Commons.defaultButton,
    width: "100%",
    padding: "12px 0",
    textAlign: "center",
    color: colors.black,
    backgroundColor: colors.primary,
    borderRadius: 12,
    fontSize: 18,
    fontWeight: "bold",
    marginTop: 12,
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  disabledButtonCardCoupon: {
    backgroundColor: colors.grayLight,
    color: colors.gray50,
    cursor: "no-drop",
  },
  authSection: {
    maxWidth: 420,
  },
  submit: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    color: colors.white,
    textAlign: "center",
    fontSize: 18,
    fontWeight: 600,
    borderRadius: 12,
    padding: 18,
    margin: "42px 0 36px 0",
    width: "100%",
  },
});

export default styles;
